import { FC, useMemo, useState } from 'react';
import { View } from 'react-native';
import Collapse from '../../../components/Collapse/Collapse';
import { ICollapseItem } from '../../../components/Collapse/Collapse.types';
import FormHelper from '../../../components/FormHelper/FormHelper';
import requestForm from '../constants';
import { IFormData } from '../../../components/FormHelper/FormHelper.types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import { Loading } from '../../../components';
import { IRequestForm } from '../types';

interface RequestFormProps {
  formSections: IRequestForm[];
}

export const RequestForm: FC<RequestFormProps> = ({
  formSections
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const sections: ICollapseItem[] = useMemo(() => {
    return formSections.map((form) => {
      return {
        title: form.formStructer.title || '',
        content: (
          <View key={form.formStructer.title}>
            <FormHelper
              formStructure={form.formStructer}
              onSubmit={async (data) => {
                if (form.onSubmit) {
                  setIsLoading(true);
                  form.onSubmit(data).finally(() => {
                    setIsLoading(false);
                  });
                }
              }}
              initValues={form.initValues}
            />
          </View>
        ),
      };
    });
  }, [formSections, setIsLoading]);

  return (
    <>
      {sections.map((section) => (
        <Collapse section={section} key={section.title} />
      ))}
      {isLoading === true && <Loading isFullScreen={true}/>}
    </>
  );
};
